import DOMPurify from "dompurify";
import MarkdownIt from "markdown-it";

const markdown = new MarkdownIt({ html: false, linkify: true, typographer: true });
markdown.disable("image");

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  "h2",
  "h3",
  "h4",
  "blockquote",
  "a",
  "code",
  "pre",
  "hr",
];

export function renderReviewMarkdown(source: string): string {
  try {
    const sanitized = DOMPurify.sanitize(markdown.render(source), {
      ALLOWED_TAGS,
      ALLOWED_ATTR: ["href", "title"],
      ALLOW_DATA_ATTR: false,
    });
    const template = document.createElement("template");
    template.innerHTML = sanitized;
    for (const link of template.content.querySelectorAll("a")) {
      const href = link.getAttribute("href") ?? "";
      if (/^https?:\/\//iu.test(href)) {
        link.target = "_blank";
        link.rel = "noopener noreferrer";
      }
    }
    return template.innerHTML;
  } catch {
    const element = document.createElement("p");
    element.textContent = source;
    return element.outerHTML;
  }
}
